import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const _socialFacebook: FunctionComponent<{ className?: string }> = ({ className }) => (
    <svg version='1.1' id='Livello_1' x='0px' y='0px' viewBox='0 0 240.9 240.9' enableBackground='new 0 0 240.9 240.9'>
        <circle fill='#1977F3' cx='120.8' cy='120.6' r='118.9' />
        <path
            fill='#FFFFFF'
            d='M165,154.9l5.3-34.4h-33V98.3c0-9.4,4.6-18.6,19.4-18.6h15V50.4c0,0-13.6-2.3-26.6-2.3
c-27.2,0-44.9,16.5-44.9,46.3v26.2H69.9v34.4h30.2V238c6.1,1,12.3,1.4,18.6,1.4s12.5-0.5,18.6-1.4v-83.1H165z'
        />
    </svg>
);

{
    /* <svg  viewBox="0 0 85 85">
    <title>Facebook</title>
    <g id="Circle_Color" data-name="Circle Color">
        <g id="Facebook"><circle id="back" fill="#3a5a99" cx="42.5" cy="42.5" r="42.5"/>
        <path id="Facebook-2" data-name="Facebook" fill="#fff" d="M63.18,19.26H21.82a2.56,2.56,0,0,0-2.56,2.56V63.18a2.56,2.56,0,0,0,2.56,2.56H44.09v-18H38v-7h6.06V35.55c0-6,3.66-9.27,9-9.27a48.14,48.14,0,0,1,5.41.28v6.27H54.81c-2.92,0-3.48,1.39-3.48,3.42v4.48h7l-.91,7h-6v18H63.18a2.56,2.56,0,0,0,2.56-2.56V21.82A2.56,2.56,0,0,0,63.18,19.26Z"/></g></g>
        </svg>;
 */
}

const SocialFacebook = styled(_socialFacebook)``;

export default SocialFacebook;
